import {Component, Inject, OnInit} from '@angular/core';
import {Constants} from '../../common/constants';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {FieldConfigName} from '../../../models';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-select-input-dialog',
  templateUrl: './select-input-dialog.component.html',
  styleUrls: ['./select-input-dialog.component.scss']
})
export class SelectInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editSelectInputForm: UntypedFormGroup;
  choices: any[];
  status: boolean;
  control: FieldConfigName;
  formArray: UntypedFormArray;
  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<SelectInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    const formGroup = <any>{
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      options: ['', []],
    };
    this.editSelectInputForm = this.formBuilder.group(formGroup);
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    const formValues = <any>{
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired,
      options: control.options?.options,
    };
    if (this.control?.options?.entite) {
      formValues.entite = control.options.entite;
    }
    this.editSelectInputForm.setValue(formValues);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editSelectInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editSelectInputForm.value);
  }
  onUpdateChoiceList(choices: { key: string }[]) {
    const data = [];
    choices.forEach((elt) => data.push({key: elt.key, value: elt.key}));
    this.editSelectInputForm.patchValue({options: data});
  }
}
